/**
 * share_event vocabulary + the no-PII referrer reducer (M6.md AC-9). Pure and
 * client-safe: the coarse growth events carry ONLY a referrer HOST, never the
 * full referrer URL (which may embed a path/query with PII). The server-only
 * recorder that persists these rows lives in `./shareEvent` (imports pg).
 */

export const SHARE_EVENT_TYPES = ["link_view", "embed_load", "embed_referrer", "attribution_click"] as const;
export type ShareEventType = (typeof SHARE_EVENT_TYPES)[number];

export type ShareEventSurface = "viewer" | "embed";

export function isShareEventType(value: unknown): value is ShareEventType {
  return typeof value === "string" && (SHARE_EVENT_TYPES as readonly string[]).includes(value);
}

/**
 * Reduce a raw `Referer` header (or any URL) to its bare host — the ONLY part
 * we ever persist. Returns null for missing/opaque/same-origin-less referrers
 * so a row is stored without a host rather than leaking a full URL.
 */
export function referrerHost(referer: string | null | undefined): string | null {
  if (!referer) return null;
  try {
    const host = new URL(referer).hostname;
    return host !== "" ? host : null;
  } catch {
    return null;
  }
}
